export const dateAddMonth = (date: Date, addMonth: number, operator: '+' | '-' = '+'): Date => {
    const newDate = new Date(date);
    operator === '+' ? newDate.setMonth(newDate.getMonth() + addMonth) : newDate.setMonth(newDate.getMonth() - addMonth);
    return new Date(newDate);
}

